var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',{attrs:{"title":"Affiliate Invitations","subtitle":_vm.subtitle}},[_c('div',[_c('Affiliate-Invitations-Table',{attrs:{"hidePosition":!_vm.singleView,"hideCompany":_vm.singleView}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }